<template>
  <button class="btn">
    <span class="btn__txt">Подписка</span>
    <svg class="btn__icon" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.80498 13.246L9.24688 7.97961H5.81353L6.43582 3.15919L2.46601 8.82903H5.44873L4.80498 13.246ZM3.11148 16L3.96982 10.1032H0L7.07292 0H8.12932L7.27935 6.70549H12L4.16788 16H3.11148Z" fill="white"/>
    </svg>
  </button>
</template>

<script setup>
  import { onMounted, onBeforeUnmount } from 'vue';
  //---------------------------
  onMounted(() => {

  });

  onBeforeUnmount(() => {

  });
</script>

<style lang="scss" scoped>
  @import "./styles";
</style>

